"use client";

import { usePathname, useRouter } from "next/navigation";
import { imageGeneratorCategories } from "../../products/_shared/image-generator-tools";
import { faqData } from "@/data/faq";
import { FaqSectionWithFaq } from "@/shared/faq-section";

export function ImageGeneratorFaq() {
  const router = useRouter();

  const pathname = usePathname();

  const generalUrl = "/products/ai-image-generator";

  if (!pathname) {
    router.replace(generalUrl);
    return null;
  }

  const slug = pathname.split("/").pop();
  const pageData = imageGeneratorCategories.find((c) => c.tool === slug);

  if (!pageData) {
    router.replace(generalUrl);
    return null;
  }

  return <FaqSectionWithFaq faqs={[...pageData.faqs, ...faqData.aiImageGenerator]} />;
}
